<template>
<!-- 未实现的净收益损失比 -->
 <div v-loading="nuplLoading"    style="width: 100%; min-height: 700px">
   <!-- 公式 -->
   <el-row type="flex" justify="center">
      <section class="formulas">
          <div>Net Unrealized Profit and Loss <i>(NUPL)</i>  =</div>
          <div>
            <span>Market Cap -Realixed Cap</span>
            <span>Market Cap </span>
          </div>
      </section>
   </el-row>
    <el-row>
      <el-col :span="24">      
        <div
          id="nuplBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../nupl/index"
export default {
  mixins:[IndexJs]
}
</script>

<style>

</style>